export const MAX_NUM_OF_APPROVERS = 10;
